// components/user/lead/sell-device/ErrorState.jsx
import React from "react";
import { FiAlertCircle } from "react-icons/fi";

const ErrorState = ({ message, isDarkMode, onGoBack }) => {
  return (
    <div className="flex items-center justify-center min-h-[60vh] px-4 py-12">
      <div className="w-full max-w-md text-center">
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-red-100 rounded-full ">
          <FiAlertCircle className="text-red-500" size={40} />
        </div>
        <h2 className={`text-2xl font-bold mb-2 ${isDarkMode ? "text-white" : "text-gray-900"}`}>
          Invalid Request
        </h2>
        <p className={`mb-6 ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
          {message || "This evaluation is no longer valid. Please go back and try again."}
        </p>
        <button
          onClick={onGoBack}
          className="px-6 py-2.5 font-semibold text-white bg-green-500 rounded-lg hover:bg-green-600 transition-colors"
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default ErrorState;